import { useCallback, useEffect, useState } from 'react'
import { trackInternalEvent } from '@rio/tracking'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { selectors } from 'builder/modules/resumeEditor'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { useTailoredDesignation } from 'builder/hooks/useTailoredDesignation'
import { FetchStatuses } from 'builder/modules/constants'
import { goToBillingPlanPage } from 'builder/utils/goToBillingPlanPage'
import { actions as jobTrackingActions } from 'builder/modules/jobTracking'
export const useTailoredResumeEdit = () => {
  const routeParams = useParams()
  const currentResume = useTypedSelector(selectors.resume)
  const originalResume = useTypedSelector(selectors.originalResume)
  const approveAutoTailoredResumeStatus = useTypedSelector(
    selectors.approveAutoTailoredResumeStatus,
  )
  const {
    averageScore: newScore,
    recommendedJobTitle,
    employerName,
  } = useTypedSelector(selectors.jobPostingAPIData)
  const oldScore = currentResume?.originalResumeAvgScore || 0
  const [isEditActive, setIsEditActive] = useState(false)
  const tailoredDesignation = useTailoredDesignation(recommendedJobTitle, employerName)
  const isApproving = approveAutoTailoredResumeStatus === FetchStatuses.loading
  const autoTailoringFromPublicJobBoard = useTypedSelector(
    selectors.autoTailoringFromPublicJobBoard,
  )

  const dispatch = useDispatch()
  const toggleEditContainer = useCallback(() => {
    setIsEditActive(!isEditActive)
  }, [isEditActive])

  useEffect(() => {
    if (autoTailoringFromPublicJobBoard.enabled) {
      dispatch(jobTrackingActions.fetchJobsRequest())
    }
  }, [autoTailoringFromPublicJobBoard.enabled, dispatch])

  const getJobTrackingPath = useCallback(() => {
    const successSearchParams = new URLSearchParams({
      mode: 'auto_tailoring_from_public_job_board',
      card_id: String(autoTailoringFromPublicJobBoard.jobCardId),
      approve_auto_tailored_resume: 'true',
      resume_id: String(currentResume?.id || routeParams.id),
    })

    return `/app/job-tracking?${successSearchParams.toString()}`
  }, [autoTailoringFromPublicJobBoard.jobCardId, currentResume?.id, routeParams.id])

  const goToPaymentPage = useCallback(() => {
    const closeSearchParams = new URLSearchParams({
      mode: 'auto_tailoring_from_public_job_board',
      show_self_tailor_modal: 'true',
      resume_id: String(currentResume?.originalResumeId),
    })

    goToBillingPlanPage({
      onSuccessRedirect: getJobTrackingPath(),
      onCloseRedirect: `/app/job-tracking?${closeSearchParams.toString()}`,
    })
    trackInternalEvent('click_finish_editing', {
      label: 'auto_tailoring_overview_screen',
      score: newScore,
    })
  }, [newScore, currentResume, getJobTrackingPath])

  return {
    oldScore,
    newScore,
    tailoredDesignation,
    toggleEditContainer,
    isEditActive,
    currentResume,
    originalResume,
    isApproving,
    goToPaymentPage,
    getJobTrackingPath,
    setIsEditActive,
  }
}
